import React from 'react'
import AppContent from 'src/components/AppContent'
import AppSidebar from 'src/components/AppSidebar'
import AppFooter from 'src/components/AppFooter'
import AppHeader from 'src/components/AppHeader'
import LoginGuard from './LoginGuard'

const DefaultLayout = () => {
  return (
    <LoginGuard>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </LoginGuard>
  )
}

export default DefaultLayout
